<section class="gr-panel" aria-label="Revocar certificado">
  <!-- Formulario -->
  <div class="download-panel-card" *ngIf="enDatos">
    <div class="download-panel-icon" aria-hidden="true">
      <i class="fas fa-ban"></i>
    </div>
    <div class="download-panel-copy gr-form-block">
      <h2>Revocar certificado</h2>
      <p>
        Ingresa los datos del titular para validar la identidad y elegir el certificado a revocar.
      </p>

      <form [formGroup]="formaForm" (ngSubmit)="validarIdentidad()" class="gr-form" novalidate>
        <div class="gr-field-grid">
          <div class="gr-field">
            <label class="gr-label" id="gr-tipo-label">Tipo de identificación *</label>
            <app-custom-select
              formControlName="tipo"
              inputId="gr-tipo"
              ariaLabelledby="gr-tipo-label"
              [options]="tiposDocumentos"
              [invalid]="camposInvalidos('tipo')">
            </app-custom-select>
            <p class="gr-err" *ngIf="camposInvalidos('tipo')">Selecciona un tipo de documento.</p>
          </div>

          <div class="gr-field">
            <label class="gr-label" for="gr-numero">Número de identificación *</label>
            <input
              id="gr-numero"
              type="text"
              class="gr-input"
              formControlName="numero"
              placeholder="Sin puntos ni espacios"
              autocomplete="off"
              [class.is-invalid]="camposInvalidos('numero')" />
            <p class="gr-err" *ngIf="camposInvalidos('numero')">{{ mensajeNumero }}</p>
          </div>

          <div class="gr-field gr-field--fecha">
            <label class="gr-label gr-label--fecha" for="gr-fecha" (click)="abrirCalendarioFecha($event)">
              Fecha de expedición *
            </label>
            <div
              class="certi-fecha-picker"
              [class.certi-fecha-picker--invalid]="camposInvalidos('fechaExpDocumento') || fechaInvalida">
              <div class="certi-fecha-picker__row">
                <input
                  id="gr-fecha"
                  type="text"
                  class="gr-input certi-fecha-picker__input"
                  formControlName="fechaExpDocumento"
                  placeholder="dd/mm/aaaa"
                  inputmode="numeric"
                  maxlength="10"
                  autocomplete="off"
                  [class.is-invalid]="camposInvalidos('fechaExpDocumento') || fechaInvalida" />
                <button
                  type="button"
                  class="certi-fecha-picker__btn"
                  (click)="abrirCalendarioFecha($event)"
                  aria-label="Abrir calendario">
                  <i class="far fa-calendar-alt" aria-hidden="true"></i>
                </button>
                <input
                  class="certi-fecha-picker__anchor"
                  [matDatepicker]="fechaPicker"
                  [formControl]="fechaMatCtrl"
                  [min]="minFechaDate"
                  [max]="maxFechaDate"
                  (dateChange)="onMatDateChange($event)"
                  tabindex="-1"
                  aria-hidden="true" />
                <mat-datepicker #fechaPicker panelClass="certi-datepicker-panel"></mat-datepicker>
              </div>
            </div>
            <p class="gr-err" *ngIf="camposInvalidos('fechaExpDocumento') || fechaInvalida">
              Fecha de expedición no válida.
            </p>
          </div>
        </div>

        <p class="gr-hint" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>

        <div class="gr-actions">
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="formaForm.invalid || fechaInvalida || loading">
            <span *ngIf="!loading">Validar identidad</span>
            <span *ngIf="loading"><i class="fas fa-spinner fa-spin" aria-hidden="true"></i> Validando…</span>
          </button>
        </div>
        <p class="gr-footnote">* Campos obligatorios</p>
      </form>
    </div>
  </div>

  <!-- Preguntas reto -->
  <div class="gr-results-card" *ngIf="enPreguntas">
    <header class="gr-results-head">
      <div class="gr-results-icon" aria-hidden="true">
        <i class="fas fa-shield-alt"></i>
      </div>
      <div class="gr-results-titles">
        <p class="gr-welcome" *ngIf="nombreSaludo">
          Hola, <strong>{{ nombreSaludo }}</strong>.
        </p>
        <h2>Preguntas de seguridad</h2>
        <p *ngIf="tituloConsulta">{{ tituloConsulta }}</p>
      </div>
      <button type="button" class="gr-link-btn" (click)="volverADatos()">
        <i class="fas fa-arrow-left" aria-hidden="true"></i>
        Volver
      </button>
    </header>

    <div class="gr-reto">
      <p class="gr-reto__lead">
        Confirma tu identidad respondiendo las preguntas. Tómate el tiempo necesario.
      </p>

      <p class="gr-hint" *ngIf="errorPreguntas" role="alert">{{ errorPreguntas }}</p>
      <div class="gr-actions" *ngIf="errorPreguntas">
        <button type="button" class="btn btn-primary" (click)="cargarPreguntas()">Reintentar</button>
      </div>

      <ng-container *ngIf="!errorPreguntas && preguntas.length">
        <p class="gr-reto__progress">
          Pregunta {{ preguntaActual + 1 }} de {{ preguntas.length }}
        </p>
        <p class="gr-reto__q">{{ preguntas[preguntaActual].texto }}</p>
        <div class="gr-reto__answers">
          <button
            type="button"
            class="gr-reto__opt"
            *ngFor="let resp of preguntas[preguntaActual].respuestas; let ri = index"
            [class.is-selected]="resp.seleccionada"
            (click)="seleccionarRespuesta(preguntaActual, ri)">
            {{ resp.respuesta || resp.texto }}
          </button>
        </div>
        <div class="gr-actions">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="anteriorPregunta()"
            [disabled]="preguntaActual === 0">
            Anterior
          </button>
          <button
            type="button"
            class="btn btn-primary"
            *ngIf="!esUltimaPregunta"
            (click)="siguientePregunta()"
            [disabled]="!tieneRespuesta(preguntaActual)">
            Siguiente
          </button>
          <button
            type="button"
            class="btn btn-primary"
            *ngIf="esUltimaPregunta"
            (click)="enviarRespuestas()"
            [disabled]="!puedeEnviarReto">
            Validar respuestas
          </button>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Listado certificados -->
  <div class="gr-results-card" *ngIf="enListado">
    <header class="gr-results-head">
      <div class="gr-results-icon" aria-hidden="true">
        <i class="fas fa-ban"></i>
      </div>
      <div class="gr-results-titles">
        <p class="gr-welcome" *ngIf="nombreSaludo">
          Hola, <strong>{{ nombreSaludo }}</strong>.
        </p>
        <h2>
          Certificados encontrados
          <span class="gr-count">{{ certificados.length }}</span>
        </h2>
        <p *ngIf="tituloConsulta">{{ tituloConsulta }}</p>
      </div>
      <button type="button" class="gr-link-btn" (click)="nuevaConsulta()">
        <i class="fas fa-arrow-left" aria-hidden="true"></i>
        Nueva consulta
      </button>
    </header>

    <div class="gr-empty" *ngIf="!certificados.length">
      <p class="gr-hint" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>
      <p *ngIf="!errorMessage">No hay certificados para mostrar.</p>
      <div class="gr-actions">
        <button type="button" class="btn btn-primary" (click)="nuevaConsulta()">Nueva consulta</button>
      </div>
    </div>

    <div class="gr-list" *ngIf="certificados.length" role="region" aria-label="Listado de certificados">
      <article
        class="gr-row"
        *ngFor="let item of certificados"
        [class.is-open]="seleccionado === item">
        <div class="gr-row__summary">
          <div class="gr-row__meta">
            <span class="gr-code gr-code--accent" [attr.title]="item.serialDispositivo">
              <span class="gr-code__k">Solicitud</span>{{ item.serialDispositivo || '—' }}
            </span>
            <span class="gr-code" [attr.title]="item.cedula">
              <span class="gr-code__k">Cédula</span>{{ item.cedula || '—' }}
            </span>
            <span class="gr-badge" [class.is-ok]="esActivo(item)">
              {{ etiquetaEstado(item.status) }}
            </span>
          </div>
          <div class="gr-row__info">
            <span class="gr-row__titular" [attr.title]="item.nombreSolicitante">
              {{ item.nombreSolicitante || '—' }}
            </span>
            <span class="gr-row__vence">Vence {{ item.fechaVencimiento || '—' }}</span>
          </div>
          <div class="gr-row__actions">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              *ngIf="seleccionado !== item"
              (click)="seleccionarCertificado(item)">
              Seleccionar
            </button>
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              *ngIf="seleccionado === item"
              (click)="cancelarSeleccion()">
              Cerrar
            </button>
          </div>
        </div>

        <div class="gr-expand" *ngIf="seleccionado === item">
          <p class="gr-expand__resume">
            Solicitud <strong>{{ seleccionado.serialDispositivo || '—' }}</strong>
            <span aria-hidden="true"> · </span>
            Vence {{ seleccionado.fechaVencimiento || '—' }}
          </p>

          <div class="gr-field">
            <label class="gr-label" id="gr-motivo-label">Motivo de revocación *</label>
            <app-custom-select
              [formControl]="motivoCtrl"
              inputId="gr-motivo"
              ariaLabelledby="gr-motivo-label"
              placeholder="Selecciona un motivo"
              [options]="opcionesMotivo">
            </app-custom-select>
          </div>

          <p class="gr-expand__desc" *ngIf="motivoSeleccionado">
            {{ motivoSeleccionado.descripcionMotivo }}
          </p>

          <details class="gr-more">
            <summary>Ver datos completos del certificado</summary>
            <dl class="gr-dl">
              <ng-container *ngFor="let row of detalleCampos">
                <ng-container *ngIf="valorDetalle(seleccionado, row.code) != null">
                  <dt>{{ row.title }}</dt>
                  <dd>{{ valorDetalle(seleccionado, row.code) }}</dd>
                </ng-container>
              </ng-container>
            </dl>
          </details>

          <p class="gr-note" role="note">
            La revocación es irreversible e inhabilita el certificado por completo.
          </p>

          <p class="gr-hint" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>

          <div class="gr-actions">
            <button type="button" class="btn btn-secondary" (click)="cancelarSeleccion()">
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary"
              (click)="confirmarRevocacion()"
              [disabled]="!motivoSeleccionado || esperandoAuth">
              Revocar certificado
            </button>
          </div>
        </div>
      </article>
    </div>
  </div>
</section>
